export default __webpack_public_path__ + "static/cashflow_202_1996_8-0a51d7630430cc33d0630d9bed3d3369.jpg";